module.exports = __webpack_public_path__ + "assets/arrow-down.21f123f3.svg";